import { render, staticRenderFns } from "./BillingMethodDisplay.vue?vue&type=template&id=2ef0c462&scoped=true&"
import script from "./BillingMethodDisplay.vue?vue&type=script&lang=js&"
export * from "./BillingMethodDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BillingMethodDisplay.vue?vue&type=style&index=0&id=2ef0c462&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0c462",
  null
  
)

export default component.exports